import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { UserInfo } from 'src/app/store/actions/user.action';
import { AppState } from 'src/app/store/app.states';
import { ViewEncapsulation } from "@angular/core";
import { ToastrService } from 'ngx-toastr';
import { WebapiService } from 'src/app/shared/services/webapi.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-seriespage',
  templateUrl: './seriespage.component.html',
  styleUrls: ['./seriespage.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SeriespageComponent implements OnInit {
  seriesid;
  constructor(private store: Store<AppState>,private toastrService: ToastrService, public webApi: WebapiService, private route: ActivatedRoute, public router: Router) {
  }

  ngOnInit(): void {
    this.store.dispatch(new UserInfo())
  }

}
